"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-overflow viewbox="0 0 4 18"><path fill-rule=evenodd d="M2 4A2 2 0 102.001.001 2 2 0 002 4zm0 7a2 2 0 10.001-3.999A2 2 0 002 11zm2 5a2 2 0 11-3.999.001A2 2 0 014 16z"></path></symbol>';
};